import { getAction, listAction, updateAction } from "@/data/connection";
import { School } from "@/data/classes/school.class";


/**
 * Gets a center entry.
 */
export const getSchoolEntry = function (value, slugOrId, recursive, status) {
	return getAction('schools', value, slugOrId, recursive, status).then(data => {
		if (data.data[0])
			return processEntry(data.data[0]);
		if (data.data)
			return processEntry(data.data);
	});
}

/**
 * Gets a list of centers.
 */
export const getSchoolsList = function (recursive, page, author) {
	return listAction('schools', recursive, page, author).then(data => {
		return { content: processList(data.data), totalSchools: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Edits a Project.
 */
export const updateSchoolEntry = function (id, body) {
	return updateAction("schools", id, body).then(data => {
		console.log("data", data)
		return data;
	});
}

/**
 * Process data.
 */
const processData = function (data) {
	let content = data.data;
	return content;
}

/**
 * Process Entry.
 */
const processEntry = function (data) {

	let content = new School(data);

	return content;
}



/**
 * Process List.
 */
const processList = function (data) {
	let content = data;

	content = content.map(value => {
		return processEntry(value)
	})

	return content;
}


// WEBPACK FOOTER //
// ./src/data/models/school.model.js